import { Typography } from '@mui/material';
import { Card } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../router/constants';
import { FoldersList } from './folders-list';
import { FolderOutline } from '@otp/icons';

export const FoldersCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    navigate(Routes.resources.path);
  };

  return (
    <Card
      isLink
      onClick={onClick}
      className="bg-[#F5FAFF] border-none w-full h-full"
    >
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        className="flex gap-2 items-center "
      >
        <FolderOutline />
        {t('resources.file-explorer.title')}
      </Typography>

      <FoldersList parentId={null} withTotalCount />

      <Typography variant="subtitle1" className="absolute bottom-4 right-12">
        {t('common.show-all')}
      </Typography>
    </Card>
  );
};
